"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardApi = exports.DashboardApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * DashboardApi - axios parameter creator
 * @export
 */
const DashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} fromSuggestedDate
         * @param {string} toSuggestedDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (fromSuggestedDate, toSuggestedDate, options = {}) => {
            // verify required parameter 'fromSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getDashboard', 'fromSuggestedDate', fromSuggestedDate);
            // verify required parameter 'toSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getDashboard', 'toSuggestedDate', toSuggestedDate);
            const localVarPath = `/api/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (fromSuggestedDate !== undefined) {
                localVarQueryParameter['from_suggested_date'] = fromSuggestedDate;
            }
            if (toSuggestedDate !== undefined) {
                localVarQueryParameter['to_suggested_date'] = toSuggestedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DashboardApiAxiosParamCreator = DashboardApiAxiosParamCreator;
/**
 * DashboardApi -
 */
var DashboardApi;
(function (DashboardApi) {
    /**
     *
     * @param {string} fromSuggestedDate
     * @param {string} toSuggestedDate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof DashboardApi
     * url /api/dashboard
     */
    async function getDashboard(fromSuggestedDate, toSuggestedDate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.DashboardApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(fromSuggestedDate, toSuggestedDate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIDashboard)(res.data);
            return res;
        });
    }
    DashboardApi.getDashboard = getDashboard;
})(DashboardApi || (exports.DashboardApi = DashboardApi = {}));
